import * as React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import "./index.css";

interface ITable {
  data: any;
  columns: Array<any>;
  defaultPageSize: number;
  showPaginationTop: boolean;
  showPaginationBottom: boolean;
}

const Table: React.SFC<ITable> = props => {
  return (
    <ReactTable
      data={props.data}
      columns={props.columns}
      defaultPageSize={props.defaultPageSize}
      showPaginationTop={props.showPaginationTop}
      showPaginationBottom={props.showPaginationBottom}
    />
  );
};

export default Table;



// WEBPACK FOOTER //
// ./src/Components/Table/index.tsx